import _ from "lodash";
import { useAuth0 } from "@auth0/auth0-react";
import * as defaultStyles from "./customStyles/default";
import * as easyStyles from "./customStyles/easy";
import * as uabStyles from "./customStyles/uab";
import * as mytravellifestyleStyles from "./customStyles/mytravellifestyle";
import * as hgvStyles from "./customStyles/hgv";
import * as kemetStyles from "./customStyles/kemet";
import * as travilyStyles from "./customStyles/travily/index.jsx";
import * as clubWyndhamStyles from "./customStyles/clubwyndham/index.jsx";
import * as mikiStyles from "./customStyles/miki/index.jsx";

import { toast } from "react-toastify";

// ============================== ITBYUS =============================
import * as atlanticStyles from "./customStyles/atlantic";
import * as festivalStyles from "./customStyles/festival";
import * as knoxtravelStyles from "./customStyles/knoxtravel";
import * as traveldealfindersStyles from "./customStyles/traveldealfinders";

import { useEffect, useState } from "react";
import { noAuthAccess, withAuth } from "./context";
import ReactPixel from "react-facebook-pixel";
import { meta_pixel_api_key } from "./variables";

export const AuthProviderHoc = (WrappedComponent) => {
  const AuthProviderHocComp = (props) => {
    const { user, getIdTokenClaims, isLoading: authIsLoading } = useAuth0();
    const [token, setToken] = useState<string | null>(null);

    useEffect(() => {
      if (!withAuth || noAuthAccess) return;

      if (!authIsLoading && !token) {
        getIdTokenClaims()
          .then((token) => {
            if (!_.get(token, "__raw")) return;
            setToken(token.__raw);
          })
          .catch(() => {});
      }
    }, [authIsLoading, user]);

    if (user) {
      return (
        <WrappedComponent
          {...props}
          token={token}
          user_id={user.sub}
          email={user.email}
          email_verified={user.email_verified}
        />
      );
    }

    return (
      <WrappedComponent
        {...props}
        withAuth={withAuth}
        user_id={null}
        email={null}
        email_verified={null}
      />
    );
  };

  return AuthProviderHocComp;
};

export function extractHTMLContent(s: string) {
  const span = document.createElement("span");
  span.innerHTML = s;
  return span.textContent || span.innerText;
}

function stylesReturner({ styles, props }) {
  if (typeof styles === "function") {
    return styles(props);
  }

  return styles;
}

export function cStyler({ type, brand, objName, props = {} }) {
  switch (`${type}.${brand}`) {
    case "type1.":
    case "type1.default":
      return stylesReturner({
        styles: _.get(defaultStyles, objName, {}) || {},
        props,
      });
    case "type1.easy":
      return stylesReturner({
        styles: _.get(easyStyles, objName, {}) || {},
        props,
      });
    case "type1.festival":
    case "type2.festival":
      return stylesReturner({
        styles: _.get(festivalStyles, objName, {}) || {},
        props,
      });
    case "type1.knoxtravel":
      return stylesReturner({
        styles: _.get(knoxtravelStyles, objName, {}) || {},
        props,
      });
    case "type1.traveldealfinders":
      return stylesReturner({
        styles: _.get(traveldealfindersStyles, objName, {}) || {},
        props,
      });
    case "type1.atlantic":
      return stylesReturner({
        styles: _.get(atlanticStyles, objName, {}) || {},
        props,
      });
    case "type1.uab":
      return stylesReturner({
        styles: _.get(uabStyles, objName, {}) || {},
        props,
      });
    case "type1.mytravellifestyle":
      return stylesReturner({
        styles: _.get(mytravellifestyleStyles, objName, {}) || {},
        props,
      });
    case "type1.hgv":
      return stylesReturner({
        styles: _.get(hgvStyles, objName, {}) || {},
        props,
      });
    case "type1.travily": {
      return stylesReturner({
        styles: _.get(travilyStyles, objName, {}) || {},
        props,
      });
    }
    case "type1.clubwyndham": {
      return stylesReturner({
        styles: _.get(clubWyndhamStyles, objName, {}) || {},
        props,
      });
    }
    case "type1.miki": {
      return stylesReturner({
        styles: _.get(mikiStyles, objName, {}) || {},
        props,
      });
    }
    case "type1.kemet":
      return stylesReturner({
        styles: _.get(kemetStyles, objName, {}) || {},
        props,
      });
    default:
      return {};
  }
}

export function findBrowser() {
  let sBrowser: string | null = null;
  const sUsrAg = navigator.userAgent;

  // The order matters here, and this may report false positives for unlisted browsers.

  if (sUsrAg.indexOf("Firefox") > -1) {
    sBrowser = "firefox";
    // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
  } else if (sUsrAg.indexOf("SamsungBrowser") > -1) {
    sBrowser = "samsung";
    // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
  } else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1) {
    sBrowser = "opera";
    // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
  } else if (sUsrAg.indexOf("Trident") > -1) {
    sBrowser = "ie";
    // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
  } else if (sUsrAg.indexOf("Edge") > -1) {
    sBrowser = "edge_legacy";
    // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
  } else if (sUsrAg.indexOf("Edg") > -1) {
    sBrowser = "edge";
    // Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.124 Safari/537.36 Edg/91.0.864.64
  } else if (sUsrAg.indexOf("Chrome") > -1) {
    sBrowser = "chrome";
    // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
  } else if (sUsrAg.indexOf("Safari") > -1) {
    sBrowser = "safari";
    // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
  } else {
    sBrowser = "unknown";
  }

  return sBrowser;
}

export function clipboardCopier(text: string) {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand("copy");
  textArea.remove();
  toast.info("URL copied to clipboard");
}

// ========================== FACEBOOK PIXEL =========================
export function initFacebookPixel() {
  const advancedMatching = {};
  const options = { autoConfig: true };
  ReactPixel.init(meta_pixel_api_key, advancedMatching, options);
}

export function sendPixelEvent(
  event: string,
  {
    data = null,
    withPageView = true,
    withInit = false,
  }: {
    data: any;
    withPageView?: boolean;
    withInit?: boolean;
  } = { data: null, withPageView: true, withInit: false },
) {
  if (!meta_pixel_api_key) return;

  if (withInit) initFacebookPixel();

  if (withPageView) ReactPixel.pageView();

  if (!event) return;

  if (data) {
    ReactPixel.track(event, data);
  } else {
    ReactPixel.track(event);
  }
}
